var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Chevron icon"),React.createElement("path",{"d":"M22.7 185.3c-2.7 0-5.5-1-7.6-3.1-4.2-4.2-4.2-11 0-15.2l74.4-74.3-74.4-74.4c-4.2-4.2-4.2-11 0-15.2 4.2-4.2 11-4.2 15.2 0L112.2 85c4.2 4.2 4.2 11 0 15.2l-81.9 81.9c-2.1 2.2-4.8 3.2-7.6 3.2z","key":1})]);
}

Chevron.defaultProps = {"viewBox":"0 0 122 185.3"};

module.exports = Chevron;

Chevron.default = Chevron;
